<template>
    <div class="qingwu">
        <div class="admin_main_block">
            <div class="admin_main_block_top">
                <div class="admin_main_block_left">
                    <!--<div><router-link to="/Admin/yijfklx/form"><el-button type="primary" icon="el-icon-plus">添加</el-button></router-link></div>-->


                    <div style="width:140px;">
                        <el-select v-model="where.xiaoq" filterable placeholder="请选择校区" @change="selectChange()">
                            <el-option label="请选择校区" :value="0"></el-option>
                            <el-option v-for="(v,k) in list['xiaoq']" :label="v.xiaoqmc" :key="k" :value="v.id"></el-option>
                        </el-select>
                    </div>

                    <div><el-input v-model="where.banjmc" placeholder="请输入班级名称"></el-input></div>

                    <div><el-input v-model="where.laosxm" placeholder="请输入老师微信昵称"></el-input></div>

                    <div><el-input v-model="where.xuesxm" placeholder="请输入学生姓名"></el-input></div>


                    <div><el-button icon="el-icon-search" @click="get_adv_list()">条件筛选</el-button></div>
                    <div>
                        <el-button icon="el-icon-refresh-right" @click="reloads()">重置</el-button>
                    </div>
                </div>

                <div class="admin_main_block_right">
                    <!--<div><el-button type="danger" icon="el-icon-delete" @click="del(select_id)">批量删除</el-button></div>-->
                </div>
            </div>
            <div class="admin_table_main">
                <el-table :data="info" @selection-change="handleSelectionChange" >
                    <el-table-column type="selection"></el-table-column>
                    <!-- <el-table-column prop="id" label="#" fixed="left" width="70px"></el-table-column> -->
                    <el-table-column prop="id" label="#"  width="70px"></el-table-column>
                    <el-table-column prop="xiaoqmc" label="校区名称"></el-table-column>
                    <el-table-column prop="banjmc" label="班级名称"></el-table-column>
                    <el-table-column prop="laosxm" label="老师微信昵称"></el-table-column>
                    <el-table-column prop="xuesxm" label="学生姓名"></el-table-column>
                    <el-table-column prop="kecsc" label="打卡时长"></el-table-column>
                    <el-table-column prop="createtime" label="创建时间">
                        <template slot-scope="scope">
                            <div v-if="scope.row.createtime<=0"> - </div>
                            <div v-else>{{scope.row.createtime|formatDate}}</div>
                        </template>
                    </el-table-column>

                    <!--<el-table-column label="操作" fixed="right" width="120px">
                        <template slot-scope="scope">
                            <el-button icon="el-icon-edit" @click="$router.push({name:'yijfklx_form',params:{id:scope.row.id}})">编辑</el-button>
                        </template>
                    </el-table-column>-->
                </el-table>
                <div class="admin_table_main_pagination">
                    <el-pagination @current-change="current_change" background layout="prev, pager, next,jumper,total" :total="total_data" :page-size="page_size" :current-page="current_page"></el-pagination>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        components: {},
        props: {},
        data() {
            return {
                list:[],
                total_data:0, // 总条数
                page_size:20,
                current_page:1,
                select_id:'',
                adv_position_id:0,
                where:{
                    laosxm:''
                },
                info:[],
            };
        },
        watch: {},
        computed: {},
        methods: {
            reloads:function(){
                this.where={};
                this.get_adv_list();
            },
            handleSelectionChange:function(e){
                let ids = [];
                e.forEach(v => {
                    ids.push(v.id);
                });
                this.select_id = ids.join(',');
            },
            get_adv_list:function(){
                let where = {};
                where.page = this.current_page;
                where.params = this.where;
                this.$get(this.$api.getBanjkcdkList,where).then(res=>{
                    console.log(res.data)
                    this.page_size = res.data.info.per_page;
                    this.total_data = res.data.info.total;
                    this.current_page = res.data.info.current_page;
                    this.info = res.data.info.data;
                    this.list = res.data;
                })

            },
            // 删除处理
            del:function(id){
                if(this.$isEmpty(id)){
                    return this.$message.error('请先选择删除的对象');
                }
                this.$post(this.$api.delBanjlb,{id:id}).then(res=>{
                    if(res.code == 200){
                        this.get_adv_list();
                        return this.$message.success("删除成功");
                    }else{
                        return this.$message.error("删除失败");
                    }
                });
            },
            current_change:function(e){
                this.current_page = e;
                this.get_adv_list();
            },
        },
        created() {
            this.get_adv_list();
        },
        mounted() {}
    };
</script>
<style lang="scss" scoped>
</style>
